__turbopack_context__.v({
  "landingPageSlice": "LandingPageSliceZone-module-scss-module__TycXtG__landingPageSlice",
  "markdown": "LandingPageSliceZone-module-scss-module__TycXtG__markdown",
});
